import { render, staticRenderFns } from "./order-policy.vue?vue&type=template&id=257c5eed&"
import script from "./order-policy.vue?vue&type=script&lang=js&"
export * from "./order-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports